import { useState } from 'react';
import Fraction from '../components/Fraction';

export default function FindXQuestion({ question, onAnswer, disabled }) {
  const { num, den, result } = question.data;
  const [value, setValue] = useState('');

  function handleSubmit() {
    if (!value || disabled) return;
    onAnswer(value);
    setValue('');
  }

  function handleKey(e) {
    if (e.key === 'Enter') handleSubmit();
  }

  return (
    <div className="question-card">
      <p className="question-prompt">Atrodi nezināmo skaitli!</p>
      <div className="fraction-of-display">
        <Fraction num={num} den={den} size="lg" />
        <span style={{ fontSize: '1.4rem', color: 'var(--color-muted)' }}>no</span>
        <span style={{ fontSize: '2.2rem', fontWeight: 700 }}>x</span>
        <span style={{ fontSize: '1.8rem' }}>=</span>
        <span style={{ fontSize: '2.2rem', fontWeight: 700 }}>{result}</span>
      </div>
      <div className="answer-input-row">
        <span style={{ fontSize: '1.4rem', marginRight: '0.5rem' }}>x =</span>
        <input
          type="number"
          min="1"
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={handleKey}
          disabled={disabled}
          placeholder="?"
          autoFocus
        />
      </div>
      <button
        className="submit-btn"
        onClick={handleSubmit}
        disabled={!value || disabled}
      >
        Pārbaudīt
      </button>
    </div>
  );
}
